import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ReturnReasonsConfigurationSkeleton = () => {
  return (
    <Styles.Container>
      <Styles.Section>
        <Skeleton variant="text" width={220} height={28} />
        <Skeleton variant="text" width="100%" height={20} />
        <Styles.ReasonsList>
          {Array.from({ length: 5 }).map((_, index) => (
            <Styles.ReasonRow key={index}>
              <Skeleton variant="rounded" width={24} height={24} />
              <Styles.ReasonBox>
                <Skeleton variant="rounded" width="100%" height={56} />
              </Styles.ReasonBox>
              <Skeleton variant="rounded" width={48} height={24} />
              <Skeleton variant="rounded" width={24} height={24} />
            </Styles.ReasonRow>
          ))}
        </Styles.ReasonsList>
        <Skeleton variant="rounded" width={200} height={40} />
      </Styles.Section>
    </Styles.Container>
  )
}

export default ReturnReasonsConfigurationSkeleton
